/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlaceOfWorkInDB
 */
export interface PlaceOfWorkInDB {
    /**
     * 
     * @type {number}
     * @memberof PlaceOfWorkInDB
     */
    userId: number;
    /**
     * 
     * @type {Date}
     * @memberof PlaceOfWorkInDB
     */
    start: Date;
    /**
     * 
     * @type {Date}
     * @memberof PlaceOfWorkInDB
     */
    end?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PlaceOfWorkInDB
     */
    deletedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PlaceOfWorkInDB
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof PlaceOfWorkInDB
     */
    id: string;
}

export function PlaceOfWorkInDBFromJSON(json: any): PlaceOfWorkInDB {
    return PlaceOfWorkInDBFromJSONTyped(json, false);
}

export function PlaceOfWorkInDBFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlaceOfWorkInDB {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
        'start': (new Date(json['start'])),
        'end': !exists(json, 'end') ? undefined : (new Date(json['end'])),
        'deletedAt': !exists(json, 'deleted_at') ? undefined : (new Date(json['deleted_at'])),
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'id': json['id'],
    };
}

export function PlaceOfWorkInDBToJSON(value?: PlaceOfWorkInDB | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.userId,
        'start': (value.start.toISOString()),
        'end': value.end === undefined ? undefined : (value.end.toISOString()),
        'deleted_at': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'id': value.id,
    };
}


